import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

import { useModalManagerContext } from '../../components/ModalManager/ModalManagerContext';

const DelaySubscriptionStep: React.FC = () => {
  const { t } = useTranslation();
  const { loadNextFlowStep, onClose, startFlow } = useModalManagerContext();

  const handleOnClose = () => {
    onClose();
  };

  return (
    <>
      <ModalHeader>{t('pauseModal.delaySubscriptionTitle')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Box>
          <Text variant="strong">
            {t('pauseModal.delaySubscriptionSubtitle')}
          </Text>
          <Text>{t('pauseModal.delaySubscriptionBody')}</Text>
          <Button onClick={() => startFlow()} variant="outlinedBig">
            {t('pauseModal.delaySubscriptionCta')}
          </Button>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button mr="4" onClick={handleOnClose} variant="outlinedBig">
          {t('pauseModal.neverMind')}
        </Button>
        <Button
          onClick={() => {
            startFlow();
            loadNextFlowStep();
          }}
          variant="blackBig"
        >
          {t('pauseModal.continueToPause')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default DelaySubscriptionStep;
